import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Billing from "views/Dashboard/Billing.js";
import RTLPage from "views/RTL/RTLPage.js";
import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
} from "components/Icons/Icons";
import ProjectTable from "views/Dashboard/ProjectTable";
import QrCode from "views/Dashboard/QrCode";
import { BsQrCode } from "react-icons/bs";
import { FaProjectDiagram } from "react-icons/fa";
import CompanyTable from "views/Dashboard/CompanyTable";
import { GiAbstract079 } from "react-icons/gi";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "Dashboard",
    icon: <HomeIcon color="inherit" />,
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/author/table",
    name: "Author Table",
    rtlName: "Author Table",
    icon: <StatsIcon color="inherit" />,
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/project/table",
    name: "Project Table",
    rtlName: "Project Table",
    icon: <FaProjectDiagram color="inherit" />,
    component: ProjectTable,
    layout: "/admin",
  },
  {
    path: "/qr-code",
    name: "QrCode",
    rtlName: "Qr-Code",
    icon: <BsQrCode color="inherit" />,
    component: QrCode,
    layout: "/admin",
  },
  {
    path: "/company-table",
    name: "Company-Table",
    rtlName: "Qr-Code",
    icon: <GiAbstract079 color="inherit" />,
    component: CompanyTable,
    layout: "/admin",
  },
  {
    path: "/rtl-support-page",
    name: "RTL",
    rtlName: "RTL",
    icon: <SupportIcon color="inherit" />,
    component: RTLPage,
    layout: "/rtl",
  },
  {
    name: "ACCOUNT PAGES",
    category: "account",
    rtlName: "account",
    state: "pageCollapse",
    views: [
      {
        path: "/profile",
        name: "Profile",
        rtlName: "Profile",
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        component: Profile,
        layout: "/admin",
      },
      {
        path: "/signin",
        name: "Sign In",
        rtlName: "Sign In",
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: "/auth",
      },
      {
        path: "/signup",
        name: "Sign Up",
        rtlName: "Sign Up",
        icon: <RocketIcon color="inherit" />,
        secondaryNavbar: true,
        component: SignUp,
        layout: "/auth",
      },
    ],
  },
];
export default dashRoutes;
